import React, { useState } from "react";
import leagueHubToolbox from "../../assets/imgs/league_hub_toolbox.png";
import arrowUpright from "../../assets/imgs/arrow-up-up-right.png";
import arrowUprightWhite from "../../assets/imgs/chevron_right.svg";
import rankings from "../../assets/imgs/rankings_toolbox.svg";
import tradeTool from "../../assets/imgs/trade_tool_tollbox.svg";
import sitStartTool from "../../assets/imgs/sit_start_tool_toolbox.svg";
import triviaTool from "../../assets/imgs/trivia_toolbox.svg";
import preSeason from "../../assets/imgs/pre-season-discount.png";
import chatWithRoto from "../../assets/imgs/chat-with-rotoBot.png";
import { useNavigate } from "react-router-dom";
import { actions } from "../../Redux/store";
import { useRevenueCatAuth } from "../../Context/RevenueCatContext/RevenueCatContext";
import PromotionalBox from "./PromotionalBox";
import look from "../../assets/imgs/look.svg";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";

export default function Toolbox() {
  const navigate = useNavigate();
  const Mixpanel = useMixpanel();
  const togglePlayerRanking = () => {
    Mixpanel.trackEvent("player_ranking_clicked", {
      name: "Player Rankings Tool Accessed",
    });
    actions.modal.openPlayerRankingModal(null);
  };

  const toggleTradeAnalyzer = () => {
    Mixpanel.trackEvent("trade_analyzer_clicked", {
      name: "Trade Analyzer Tool Accessed",
    });
    actions.modal.openTradeAnalyzerModal(null);
  };

  const {
    isSubscribed,
    customerInfo,
    yearlySubscription,
    monthlySubscription,
  } = useRevenueCatAuth();

  // Assuming we have an isInSeason flag - you'll need to get this from your state management or context
  // For now, I'm adding it as a constant for demonstration
  const isInSeason = false; // Set this to true or false based on your application's state

  console.log("Toolbox isSubscribed", isSubscribed);
  console.log("Toolbox customerInfo", customerInfo);
  console.log("Toolbox yearlySubscription", yearlySubscription);
  console.log("Toolbox monthlySubscription", monthlySubscription);

  // Define all card data, we'll filter them later
  const allCardData = [
    {
      title: "Rankings",
      desc: "Our very own AI-powered rankings",
      img: rankings,
      toggle: togglePlayerRanking,
      isPremium: false, // Rankings are free
      showAlways: true, // Always show regardless of season
    },
    {
      title: "Trivia",
      desc: "Test your NFL knowledge",
      img: triviaTool,
      isPremium: true, // Draft Tool is premium
      showAlways: false, // Only show during in-season
      requiresInSeason: true, // This tool only shows during in-season
    },
    {
      title: "Trade Tool",
      desc: "Evaluate trades with precision",
      toggle: toggleTradeAnalyzer,
      img: tradeTool,
      isPremium: false, // Trade are free
      showAlways: true, // Always show regardless of season
    },
    {
      title: "Sit/Start Tool",
      desc: "Pick the perfect lineup fast",
      link: "/sit-start-decider",
      img: sitStartTool,
      isPremium: true, // Sit/Start Tool is premium
      showAlways: true, // Always show regardless of season
      isLocked: true, // Locked for all users
    },
  ];

  // Filter cards based on season condition
  const cardData = allCardData.filter(
    (card) => card.showAlways || (card.requiresInSeason && isInSeason),
  );

  return (
    <>
      <div className="py-[20px] px-[10px]">
        {/* Header Section */}
        {/* <div className="flex items-center justify-between">
          <span className="text-[20px] text-white font-semibold leading-[30px] max-w-[94px]">
            FANTASY TOOLS
          </span>
          <div className="flex items-center gap-2">
            <div className="w-[40px] h-[40px] rounded-full flex justify-center items-center border border-[#28282A] cursor-pointer">
              <img src={calendar} alt="calendar" />
            </div>
            <div className="w-[40px] h-[40px] rounded-full flex justify-center items-center border border-[#28282A] cursor-pointer">
              <img src={searchToolbox} alt="search toolbox" />
            </div>
          </div>
        </div> */}

        {/* Promotional Content */}
        <div className="mt-[5px]">
          {isSubscribed ? (
            <PromotionalBox
              image={chatWithRoto}
              title="Chat with RotoBot"
              description="Instantly pull advanced player stats and trends."
              onClick={() => navigate("/chatbot-ai")}
              arrowImage={arrowUpright}
            />
          ) : (
            // <PromotionalBox
            //   image={leagueHubToolbox}
            //   title="League Hub"
            //   description="Get tailored insights now"
            //   arrowImage={arrowUpright}
            // />
            <PromotionalBox
              image={preSeason}
              title="Pre-Season Discount"
              description="Annual Pro Subscription at 60% off."
              onClick={() => navigate("/chatbot-paywall-v2")}
              arrowImage={arrowUpright}
            />
          )}
        </div>

        <div className="mt-[30px]">
          <div className="border-t-[1px] border-white/35 pt-[20px] flex-col space-y-[10px]">
            {/* Tool Cards */}
            {cardData.map((card, index) => (
              <div
                className={`flex cursor-pointer bg-[#1A1F2B] rounded-[20px] p-[20px] transition-transform duration-300 ease-in-out hover:scale-98 active:scale-95 ${
                  (card.isPremium && !isSubscribed) || card.isLocked
                    ? "opacity-50"
                    : ""
                }`}
                key={index}
                onClick={() => {
                  if (card.isLocked) {
                    // Locked for all users - could show a message or navigate to a coming soon page
                    return;
                  } else if (card.toggle && (!card.isPremium || isSubscribed)) {
                    card.toggle();
                  } else if (card?.link && (!card.isPremium || isSubscribed)) {
                    navigate(card?.link);
                  } else if (card.isPremium && !isSubscribed) {
                    // Optional: Navigate to subscription page when premium feature is clicked
                    navigate("/chatbot-paywall-v2");
                  }
                }}
              >
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-[32px] h-[32px]"
                />
                <div className="flex items-center justify-between gap-[20px] w-full h-full pl-[15px]">
                  <div className="flex flex-col justify-start">
                    <span className="text-white text-[15px] sm:text-[16px] font-normal">
                      {card.title}
                    </span>
                    <span className="text-white/50 text-[11px] sm:text-[12px] mt-[3px] font-normal ">
                      {card.desc}
                    </span>
                  </div>

                  <div className="cursor-pointer">
                    <img
                      src={
                        card.isLocked || (card.isPremium && !isSubscribed)
                          ? look
                          : arrowUprightWhite
                      }
                      alt={
                        card.isLocked || (card.isPremium && !isSubscribed)
                          ? "look"
                          : "arrowUpright"
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
